function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "instagram_d",
  cx: "30.274%",
  cy: "100%",
  r: "123.405%",
  fx: "30.274%",
  fy: "100%",
  gradientTransform: "matrix(.64069 .40284 -.20294 .6587 .312 .22)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FED276"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "17.024%",
  stopColor: "#FDBD61",
  stopOpacity: 0.975
}), /*#__PURE__*/React.createElement("stop", {
  offset: "45.408%",
  stopColor: "#F6804D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E83D5C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "instagram_c",
  x1: "66.814%",
  x2: "98.343%",
  y1: "-10.507%",
  y2: "111.451%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#4E60D3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "14.276%",
  stopColor: "#913BAF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "76.146%",
  stopColor: "#D52D88"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#F26D4F"
})), /*#__PURE__*/React.createElement("path", {
  id: "instagram_a",
  d: "M16.297 0c2.912.005 3.476.026 4.887.09 1.597.073 2.687.327 3.642.698.986.383 1.822.896 2.656 1.73.834.834 1.347 1.67 1.73 2.656.371.955.625 2.045.698 3.642.073 1.6.09 2.11.09 6.184s-.017 4.585-.09 6.184c-.073 1.597-.327 2.687-.697 3.642-.384.986-.897 1.822-1.73 2.656-.835.834-1.671 1.347-2.657 1.73-.955.371-2.045.625-3.642.698-1.6.073-2.11.09-6.184.09s-4.585-.017-6.184-.09c-1.597-.073-2.687-.327-3.642-.697-.986-.384-1.822-.897-2.656-1.73-.834-.835-1.347-1.671-1.73-2.657C.417 23.87.163 22.78.09 21.184.026 19.773.005 19.21 0 16.297v-2.594c.005-2.912.026-3.476.09-4.887.073-1.597.327-2.687.698-3.642.383-.986.896-1.822 1.73-2.656.834-.834 1.67-1.347 2.656-1.73C6.13.417 7.22.163 8.816.09 10.227.026 10.79.005 13.703 0zm-.607 2.703h-1.38c-3.377.002-3.885.02-5.371.087-1.463.067-2.257.311-2.786.517-.7.272-1.2.597-1.724 1.122-.525.525-.85 1.024-1.122 1.724-.206.529-.45 1.323-.517 2.786-.068 1.486-.085 1.994-.087 5.37v1.381c.002 3.377.02 3.885.087 5.371.067 1.463.311 2.257.517 2.786.272.7.597 1.2 1.122 1.724.525.525 1.024.85 1.724 1.122.529.206 1.323.45 2.786.517 1.485.068 1.994.085 5.37.087h1.381c3.377-.002 3.886-.02 5.371-.087 1.463-.067 2.257-.311 2.786-.517.7-.272 1.2-.597 1.724-1.122.525-.525.85-1.024 1.122-1.724.206-.529.45-1.323.517-2.786.068-1.486.085-1.994.087-5.37V14.31c-.002-3.377-.02-3.885-.087-5.371-.067-1.463-.311-2.257-.517-2.786-.272-.7-.597-1.2-1.122-1.724-.525-.525-1.024-.85-1.724-1.122-.529-.206-1.323-.45-2.786-.517-1.486-.068-1.994-.085-5.37-.087zM15 7.297c4.254 0 7.703 3.449 7.703 7.703 0 4.254-3.449 7.703-7.703 7.703-4.254 0-7.703-3.449-7.703-7.703 0-4.254 3.449-7.703 7.703-7.703zM15 10c-2.761 0-5 2.239-5 5s2.239 5 5 5 5-2.239 5-5-2.239-5-5-5zm8.007-4.807c.994 0 1.8.806 1.8 1.8s-.806 1.8-1.8 1.8-1.8-.806-1.8-1.8.806-1.8 1.8-1.8z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "instagram_b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#instagram_a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#instagram_a"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#instagram_b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#instagram_c)",
  d: "M22.852 0C27.187 0 30 2.813 30 7.148v15.704C30 27.187 27.187 30 22.852 30H7.148C2.813 30 0 27.187 0 22.852V7.148C0 2.813 2.813 0 7.148 0h15.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#instagram_d)",
  d: "M30 24.792C29.243 28.01 26.668 30 23.027 30H7.203C2.834 30 0 27.136 0 22.722V10.107C2.404 9.39 4.999 9 7.705 9 19.049 9 28.434 15.863 30 24.792z"
})));

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram.96ed2c7c.svg";
export { ForwardRef as ReactComponent };